module.exports = __webpack_public_path__ + "img/5_100.8462300c.png";